import { getOrdersCount } from "action/utils/getOrdersCount";
import { removeSavedItemApi } from "api/shopping-cart/removeSavedItemApi";
import { refreshShoppingCart } from "./refreshShoppingCart";
import { setShoppingCartState } from "./setShoppingCartState";

/*
 * saved list actions
 */

export function removeSavedItem(sku: any, callback = null) {
  return (dispatch: any, getState: any) => {
    // dispatch(showLoader());
    const userCart = getState().shoppingCart;
    removeSavedItemApi(sku).then(() => {
      // dispatch(hideLoader());
      const updatedCart = {
        ...userCart,
        savedItems: userCart.savedItems.filter((item) => item.sku !== sku),
      };
      // so that UI update immediately
      dispatch(setShoppingCartState(updatedCart));
      if (callback) {
        callback();
      }
      dispatch(getOrdersCount());
      dispatch(refreshShoppingCart(null, { loader: false }));
    });
  };
}
